import React from "react";
import { useTranslation } from "react-i18next";
import { fmtDateTime } from "../../lib/format";

const STATUS_KEYS = {
  pending: "platform.inv_status_pending",
  accepted: "platform.inv_status_accepted",
  revoked: "platform.inv_status_revoked",
  expired: "platform.inv_status_expired",
};

/**
 * The recent Owner invitations of one organization.
 *
 * The invited address is shown because the platform administrator must know who
 * was invited. No token, no token prefix and no user id is ever part of the read
 * model, so there is nothing here to redact.
 */
export const PlatformInvitationHistory = ({ entries }) => {
  const { t } = useTranslation();
  const rows = Array.isArray(entries) ? entries : [];

  return (
    <div className="qw-card" data-testid="platform-invitation-history">
      <div style={{ fontWeight: 600, marginBottom: 12 }}>{t("platform.invitation_history")}</div>
      {rows.length === 0 ? (
        <div className="qw-empty" data-testid="platform-invitation-history-empty">
          {t("platform.invitation_history_empty")}
        </div>
      ) : (
        <ul className="qw-platform-audit">
          {rows.map((entry) => (
            <li key={entry.id} data-testid={`platform-invitation-row-${entry.id}`}>
              <div className="qw-platform-audit-head">
                <strong>{t(STATUS_KEYS[entry.status] || "platform.inv_status_pending")}</strong>
                <span className="qw-help">{fmtDateTime(entry.created_at)}</span>
              </div>
              <div className="qw-help">{entry.invited_email}</div>
              <div className="qw-help">
                {entry.flow ? t(`platform.flow_${entry.flow}`) : ""}
                {entry.accepted_at ? ` · ${t("platform.inv_accepted_at")}: ${fmtDateTime(entry.accepted_at)}` : ""}
                {entry.revoked_at ? ` · ${t("platform.inv_revoked_at")}: ${fmtDateTime(entry.revoked_at)}` : ""}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PlatformInvitationHistory;
